<template>
  <transition name="fade">
    <div class="mfp-wrap" v-if="isOpen">
      <div
        class="mfp-container"
        ref="container"
        @click="checkClick"
        @keydown="checkKeyDown"
        tabindex="1"
      >
        <div class="popup-block">
          <button
            title="Close (Esc)"
            type="button"
            class="mfp-close"
            @click.prevent="$emit('modal-close')"
          >
            ×
          </button>
          <div>
            <h3>{{ activeFabric.title }}</h3>
            <div v-if="additionalDetails.description">
              {{ additionalDetails.description.join("") }}
            </div>
            <dl>
              <template v-if="additionalDetails.content">
                <dt>Content:</dt>
                <dd>{{ additionalDetails.content.join("") }}</dd>
              </template>
              <template v-if="additionalDetails.rub_count">
                <dt>Rub Count:</dt>
                <dd>{{ additionalDetails.rub_count.join("") }}</dd>
              </template>
              <template v-if="additionalDetails.cleaning_code">
                <dt>Cleaning Code:</dt>
                <dd>{{ additionalDetails.cleaning_code.join("") }}</dd>
              </template>
              <template v-if="additionalDetails.best_for">
                <dt>Best For:</dt>
                <dd>{{ additionalDetails.best_for.join(", ") }}</dd>
              </template>
              <template v-if="additionalDetails.collection_type">
                <dt>Finish:</dt>
                <dd>{{ additionalDetails.collection_type.join("") }}</dd>
              </template>
              <template v-if="additionalDetails.collection_finish">
                <dt>Type:</dt>
                <dd>{{ additionalDetails.collection_finish.join("") }}</dd>
              </template>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "FabricModal",
  props: {
    isOpen: Boolean,
    activeFabric: Object,
  },
  data() {
    return {
      additionalDetails: this.activeFabric.additional_details || {},
    };
  },
  updated() {
    if (this.isOpen) {
      this.$refs.container.focus();
      this.additionalDetails = this.activeFabric.additional_details;
    }
  },
  methods: {
    checkClick(e) {
      if (e.target.classList.contains("mfp-container")) {
        this.$emit("modal-close");
      }
    },
    checkKeyDown(e) {
      if (e.keyCode == 27) {
        this.$emit("modal-close");
      }
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
h3 {
  font-family: var(--oddit-heading-font);
  font-weight: 800;
  font-style: normal;
  letter-spacing: 0.25px;
  font-size: 1.5em;
  margin-top: 0;
}
.mfp-wrap {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1043;
  position: fixed;
  outline: 0 !important;
  -webkit-backface-visibility: hidden;
}
.mfp-container {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 8px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.popup-block {
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.95);
  padding: 20px 30px;
  text-align: left;
  max-width: 400px;
  margin: 40px auto;
  position: fixed;
  right: 8%;
  top: 10%;
  -webkit-box-shadow: 0 0 20px 3px rgba(187, 187, 187, 0.44);
  -moz-box-shadow: 0 0 20px 3px rgba(187, 187, 187, 0.44);
  -ms-box-shadow: 0 0 20px 3px rgba(187, 187, 187, 0.44);
  -o-box-shadow: 0 0 20px 3px rgba(187, 187, 187, 0.44);
  box-shadow: 0 0 20px 3px rgba(187, 187, 187, 0.44);
}
@media screen and (max-width: 590px) {
  .popup-block {
    right: 6px;
  }
}
@media screen and (min-width: 1181px) {
  .popup-block {
    right: calc(50vw - 570px);
  }
}
.mfp-close {
  width: 44px;
  height: 44px;
  line-height: 44px;
  position: absolute;
  right: 0;
  top: 0;
  text-decoration: none;
  text-align: center;
  padding: 0 0 18px 10px;
  font-style: normal;
  font-size: 2.5em;
  font-weight: 300;
  opacity: 1;
  font-family: Arial, Baskerville, monospace;
  overflow: visible;
  cursor: pointer;
  background: 0 0;
  border: 0;
  -webkit-appearance: none;
  display: block;
  outline: 0;
  z-index: 1046;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin: 0;
  color: #726e5e;
}
dt {
  display: inline-block;
}
dd,
dt {
  font-weight: 700;
  text-transform: uppercase;
}
dd {
  color: #cfb52c;
  display: inline;
  margin-inline-start: 5px;
}
dd::after {
  content: "";
  display: block;
}
</style>
